import { FormSection, Link, Timeline } from '@ksyos/design-system';
import { useSelector } from 'react-redux';
import type { IReduxState } from '@frontend/configureStore';
import { useProcessStartWizardWithCards } from '@frontend/utils/hooks/useProcessStartWizardWithCards';

export function DermaCwondV1FollowingSteps() {
    const hasProcessStartWizardWithCards = useProcessStartWizardWithCards();
    const selectedEmploymentId = useSelector((state: IReduxState) => state.authentication.selectedEmploymentId);

    if (!hasProcessStartWizardWithCards) {
        return null;
    }

    return (
        <FormSection title="Vervolgstappen wondzorg">
            <Timeline>
                <Timeline.Item>De Ksyos specialist ontvangt de consultaanvraag</Timeline.Item>
                <Timeline.Item>Deze specialist beoordeelt het consult binnen 2-3 werkdagen</Timeline.Item>
                <Timeline.Item>
                    Je ontvangt het advies van de specialist (beleid en diagnose) in het Ksyos platform en via Edifact
                    in je HIS als je je{' '}
                    <Link
                        openInNewTab={true}
                        to={`/employments/${selectedEmploymentId}/personalSettings`}
                        variant="link"
                    >
                        zorgmailnummer hebt doorgegeven
                    </Link>
                </Timeline.Item>
            </Timeline>
        </FormSection>
    );
}
